import { IAddressBase } from '../../models/address';
import { IFeatureGroupBase } from '../../models/features';
import { IUserAssignmentBase, IUserBase, UserGender } from '../../models/users';
import { IVentureBase } from '../../models/ventures';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IUserAssignment extends IUserAssignmentBase {
  featureGroup: IFeatureGroupBase;
  venture?: IVentureBase;
}

export interface IUpdatedUser extends IUserBase {
  userAssignments: IUserAssignment[];
}

interface IUpdateEmployeeUsersService {
  address?: IAddressBase;
  userId: string;
  bio?: string;
  birthDate?: Date;
  cpf?: string;
  email: string;
  gender?: UserGender;
  featureGroupId: string;
  name: string;
  phone?: string;
  venturesId?: string[];
}

export const updateEmployeeUsersService = async ({
  address,
  bio,
  birthDate,
  cpf,
  email,
  gender,
  featureGroupId,
  name,
  phone,
  venturesId,
  userId,
}: IUpdateEmployeeUsersService): Promise<IUpdatedUser> => {
  const { data } = await jhsfBookingsApi.put<IUpdatedUser>(
    `/users/employees/${userId}`,
    {
      address,
      bio,
      birthDate,
      cpf,
      email,
      gender,
      featureGroupId,
      name,
      phone,
      venturesId,
    },
  );

  return data;
};
